/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {BasicButton} from '../UI/BasicButton'
import {ToolTipUI} from '../UI/ToolTipUI'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'

// import {
//   activityTypeConst,
//   sortActivityConst,
//   activityStatusConst,
//   sortInvestorCrmConst,
//   dataRoomTypeConst,
// } from '../../../investor-crm/core/_constants'

import {SortInvestorCrmFilter} from '../../../investor-crm/core/_constants'
import {InvestorDBFilter} from '../../../investor-database/core/_constants'
// import {sortInvestorDbConst, fundTypeOptions} from '../../../investor-database/core/_constants'

import {useInvestorDatabase} from '../../../investor-database/core/InvestorContext'
import {useThemeMode} from '../../../../../_metronic/partials'
// import {
//   investorUpdateFilterConst,
//   pitchDeckFilterConst,
//   templateFilterConst,
//   InvestorUpdateFilterForEmail,
// } from '../../../investor-updates/core/_constants'

import {InvestorRelationFilter} from '../../../investor-updates/core/_constants'

import Select from 'react-select'
import {
  getFocusArea,
  getInvestorGeography,
  getInvestorLocation,
  getStageFocus,
} from '../../../investor-database/core/_requests'
import FilterPills from './FilterPills'
import crossIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
import {useDigitalSigning} from '../../../digital-signing/core/DigitalSigningContext'
import {DigitalSigningFilter} from '../../../digital-signing/core/_constants'
import {ToolTipUIForModal} from '../UI/ToolTipUIForModal'
import {useStakeholders} from '../../../stakeholders/Stakeholders'
import {
  actionOptions,
  activityLogFilterOptions,
  convertibleSecurityClassesRateOptions,
  FounderPromoterOptions,
  frequencyOptions,
  reportOptions,
  securityPermissionOptions,
  stakeholdersTypeOptions,
  urgencyOptions,
} from '../../../stakeholders/founders-and-promoters/core/_constants'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {ComplianceAttendanceType} from '../../../stakeholders/stakeholders-and-investors/core/_constants'

// import {
//   DocumentsSignatureStatusOptions,
//   DocumentsStatusOptions,
//   TemplateTypeOptions,
// } from '../../../digital-signing/core/_constants'

export const Filter = ({
  isActivityFilter,
  set_sort_by_activity,
  set_sort_order_activty,
  setFilterActivity,
  setIsActivityFilter,
  investorCrmFilter,
  setInvestorCrmFilter,
  set_sort_by_investor,
  set_sort_order_investor,
  dataRoomStatus,
  setDataRoomStatus,
  onResetFilter,
  setOnResetFilter,
}: {
  isActivityFilter?: boolean

  set_sort_by_activity?: Dispatch<SetStateAction<string | undefined>>
  set_sort_order_activty?: Dispatch<SetStateAction<string | undefined>>
  setFilterActivity?: Dispatch<SetStateAction<string | undefined>>
  setIsActivityFilter?: Dispatch<SetStateAction<boolean>>
  investorCrmFilter?: boolean

  setInvestorCrmFilter?: Dispatch<SetStateAction<boolean>>
  setDataRoomFilter?: Dispatch<SetStateAction<boolean>>
  set_sort_by_investor?: Dispatch<SetStateAction<string | undefined>>
  set_sort_order_investor?: Dispatch<SetStateAction<string | undefined>>

  setDataRoomStatus?: Dispatch<SetStateAction<string>>
  dataRoomStatus?: string
  onResetFilter?: boolean
  setOnResetFilter?: Dispatch<SetStateAction<boolean>>
}) => {
  const {formatMessage} = useIntl()
  const {
    investorDbFilter,
    setInvestorDbFilter,
    set_sort_by_investorDb,
    set_sort_order_investorDb,
    investorUpdateFilter,
    setInvestorUpdateFilter,
    pitchDeckFilter,
    setPitchDeckFilter,
    setInvestorUpdateStatusFilter,
    setpitchDeckStatusFilter,
    setTemplateStatusFilter,
    setTemplateFilter,
    templateFilter,
    emailFilter,
    setEmailFilter,
    setEmailStatusFilter,
    investorUpdateStatusFilter,
    pitchDeckStatusFilter,
    emailStatusFilter,
    templateStatusFilter,
    dataRoomFilter,
    setDataRoomFilter,
    contextTargetSectors,
    setContextTargetSectors,
    contextStageFocus,
    setContextStageFocus,
    contextInvestorLocation,
    setContextInvestorLocation,
    setSelectedContextTargetValue,
    setSelectedStageContextFocusValue,
    setSelectedTargetContextLocationValue,
    setSelectedTargetContextGeographiesValue,
    setSelectedTargetContextInvestorTypeValue,
    contextInvestorGeographies,
    setContextInvestorGeographies,
    setBlockOutsideClick,
  } = useInvestorDatabase()

  const closeFilter = () => {
    setBlockOutsideClick(false)
    setInvestorDbFilter(false)
    setInvestorUpdateFilter(false)
    setPitchDeckFilter(false)
    setDataRoomFilter(false)
    setTemplateFilter(false)
    setEmailFilter(false)
    setIsActivityFilter && setIsActivityFilter!(false)
    setInvestorCrmFilter && setInvestorCrmFilter(false)
    setTemplateFilter(false)
    setTemplateTypesFilter(false)
    setFounderPromoterFilter(false)
    setTeamManagementFilter(false)
    setShareSecurityClassesSortFilter(false)
    setBoardMemberFilter(false)
    setLegalCompilanceFilter(false)
    setComplianceMeetingFilter(false)
    setFinanceAccountsFilter(false)
    setAdvisorsMentorsFilter(false)
    setDocumentsSubmissionFilter(false)
    setConvertibleSecurityClassesFilter(false)
    setWarrantSecurityClassesFilter(false)
    setShareTransactionFilter(false)
    setConvertibleTransactionFilter(false)
    setWarrantTransactionFilter(false)
    setBuybackTransactionFilter(false)
    setTransferTransactionFilter(false)
    setShareholderFilter(false)
    setActivityLogFilter(false)
    setSecurityPermissionFilter(false)
    setSelectedLevelFilter(false)
    setSelectedActionFilter(false)
    setSelectedReportFilter(false)
    setSelectedScheduleFilter(false)
  }

  useEffect(() => {
    if (onResetFilter) {
      setSelectedShareSecurityClassesSortValue('')
      setSelectedConvertibleSecurityClassesRateValue('')
      setSelectedConvertibleSecurityClassesSortValue('')
      setSelectedWarrantSecurityClassesSortValue('')
      setSelectedShareTransactionSortValue('')
      setSelectedShareTransactionDateValue('')
      setSelectedConvertibleTransactionSortValue('')
      setSelectedConvertibleTransactionDateValue('')
      setSelectedWarrantTransactionSortValue('')
      setSelectedWarrantTransactionDateValue('')
      setSelectedBuybackTransactionDateFilter('')
      setSelectedBuybackTransactionSortValue('')
      setSelectedTransferTransactionDateValue('')
      setSelectedTransferTransactionSortValue('')
      setSelectedActivityLogTypeFilterValue('')
      setSelectedSecurityPermissionTypeFilterValue('')
      setSelectedLevelTypeFilterValue('')

      if (setOnResetFilter) {
        setOnResetFilter(false)
      }
    }
  }, [onResetFilter])

  const deleteFilter = (pillName: string, contextName: any, filterState: any) => {
    const filteredFilters = appliedFilter.filter((item: {name: string}) => item.name !== pillName)
    setAppliedFilter(filteredFilters)
    filterState('')
    contextName('')
  }

  const {
    sortInvestorCrmConst,
    activityTypeConst,
    sortActivityConst,
    activityStatusConst,
    dataRoomTypeConst,
  } = SortInvestorCrmFilter()

  const {sortInvestorDbConst, fundTypeOptions} = InvestorDBFilter()

  const {emailFilterConst, investorUpdateFilterConst, pitchDeckFilterConst, templateFilterConst} =
    InvestorRelationFilter()

  const {DocumentsSignatureStatusOptions, DocumentsStatusOptions, TemplateTypeOptions} =
    DigitalSigningFilter()

  const [filterLoading, setFilterLoading] = useState(false)
  const [appliedFilter, setAppliedFilter] = useState<any>([])
  //Activity
  const [activitytype, setActivityType] = useState<string>('')
  const [activityStatus, setActivityStatus] = useState<string>('')
  const [sortActivity, setSortActivity] = useState<string>('')
  //Investor
  const [sortInvestorCrm, setSortInvestorCrm] = useState<string>('')

  //Investor DB
  const [sortInvestorDb, setSortInvestorDb] = useState<string>('')
  const [selectedTargetValue, setSelectedTargetValue] = useState<any>('')

  const [searchTargetValue, setSearchTargetValue] = useState<any>('')
  const handleSelectTargetChange = (selectedOption: any) => {
    setSelectedTargetValue(selectedOption)
  }

  const [selectedStageFocusValue, setSelectedStageFocusValue] = useState<any>('')
  const [searchFocusValue, setSearchFocusValue] = useState<any>('')
  const handleSelectFocusChange = (selectedOption: any) => {
    setSelectedStageFocusValue(selectedOption)
  }

  const [selectedTargetLocationValue, setSelectedTargetLocationValue] = useState<any>('')
  const [searchLocationValue, setSearchLocationValue] = useState<any>('')
  const [searchGeographiesValue, setSearchGeographiesValue] = useState<any>('')
  const [selectedTargetGeographiesValue, setSelectedTargetGeographiesValue] = useState<any>('')
  const [selectedTargetInvestorTypeValue, setSelectedTargetInvestorTypeValue] = useState<any>('')

  // Digital Signing
  const [selectedTemplateTypeValue, setSelectedTemplateTypeValue] = useState<any>('')
  const [selectedDocumentsStatusValue, setSelectedDocumentsStatusValue] = useState<any>('')
  const [selectedDocumentsSignatureStatusValue, setSelectedDocumentsSignatureStatusValue] =
    useState<any>('')
  const {
    templateTypesFilter,
    setTemplateTypesFilter,
    setSelectedTemplateTypeFilter,
    documentsSubmissionFilter,
    setDocumentsSubmissionFilter,
    setSelectedDocumentStatusFilter,
    setSelectedDoucmentSignatureStatusFilter,
  } = useDigitalSigning()

  // Stakeholders
  const {
    founderPromoterFilter,
    setFounderPromoterFilter,
    setSelectedFounderPromoterTypeFilter,
    setSelectedFounderPromoterSortTypeFilter,
    teamManagementFilter,
    shareSecurityClassesSortFilter,
    setTeamManagementFilter,
    setShareSecurityClassesSortFilter,
    setSelectedShareSecurityClassesSortFilter,
    setSelectedTeamManagementTypeFilter,
    boardMemberFilter,
    setBoardMemberFilter,
    setSelectedBoardMemberTypeFilter,
    legalCompilanceFilter,
    setLegalCompilanceFilter,
    setSelectedLegalCompilanceTypeFilter,
    setSelectedLegalCompilanceSortTypeFilter,
    financeAccountsFilter,
    setFinanceAccountsFilter,
    setSelectedFinanceAccountsTypeFilter,
    setSelectedFinanceAccountsSortTypeFilter,
    advisorsMentorsFilter,
    setAdvisorsMentorsFilter,
    setSelectedAdvisorsMentorsTypeFilter,
    setSelectedAdvisorsMentorsSortTypeFilter,
    setSelectedConvertibleSecurityClassesSortFilter,
    setSelectedConvertibleSecurityClassesRateFilter,
    convertibleSecurityClassesFilter,
    setConvertibleSecurityClassesFilter,
    warrantSecurityClassesFilter,
    setWarrantSecurityClassesFilter,
    setSelectedWarrantSecurityClassesSortFilter,
    complianceMeetingFilter,
    setComplianceMeetingFilter,
    setSelectedComplianceMeetingTypeFilter,
    setSelectedComplianceMeetingDateFilter,

    shareTransactionFilter,
    setShareTransactionFilter,
    setSelectedShareTransactionSortFilter,
    setSelectedShareTransactionDateFilter,

    convertibleTransactionFilter,
    setConvertibleTransactionFilter,
    setSelectedConvertibleTransactionSortFilter,
    setSelectedConvertibleTransactionDateFilter,

    warrantTransactionFilter,
    setWarrantTransactionFilter,
    setSelectedWarrantTransactionSortFilter,
    setSelectedWarrantTransactionDateFilter,

    buybackTransactionFilter,
    setBuybackTransactionFilter,
    setSelectedBuybackTransactionSortFilter,
    setSelectedBuybackTransactionDateFilter,

    transferTransactionFilter,
    setTransferTransactionFilter,
    setSelectedTransferTransactionSortFilter,
    setSelectedTransferTransactionDateFilter,

    shareholderFilter,
    setShareholderFilter,
    setSelectedShareholderTypeFilter,
    setSelectedShareholderSortTypeFilter,

    activityLogFilter,
    setActivityLogFilter,
    setSelectedActivityLogTypeFilter,

    securityPermissionFilter,
    setSecurityPermissionFilter,
    setSelectedSecurityPermissionTypeFilter,

    selectedLevelFilter,
    setSelectedLevelFilter,
    setSelectedLevelTypeFilter,

    selectedActionFilter,
    setSelectedActionFilter,
    setSelectedActionTypeFilter,

    selectedReportFilter,
    setSelectedReportFilter,
    setSelectedReportTypeFilter,

    selectedScheduleFilter,
    setSelectedScheduleFilter,
    setSelectedScheduleTypeFilter,
  } = useStakeholders()

  const [selectedFounderPromoterValue, setSelectedFounderPromoterValue] = useState<any>('')
  const [selectedFounderPromoterSortValue, setSelectedFounderPromoterSortValue] = useState<any>('')
  const [selectedTeamManagementSortValue, setSelectedTeamManagementSortValue] = useState<any>('')
  const [selectedShareSecurityClassesSortValue, setSelectedShareSecurityClassesSortValue] =
    useState<any>('')
  const [selectedBoardMemberSortValue, setSelectedBoardMemberSortValue] = useState<any>('')
  const [selectedLegalCompilanceValue, setSelectedLegalCompilanceValue] = useState<any>('')
  const [selectedLegalCompilanceSortValue, setSelectedLegalCompilanceSortValue] = useState<any>('')
  const [selectedFinanceAccountsValue, setSelectedFinanceAccountsValue] = useState<any>('')
  const [selectedFinanceAccountsSortValue, setSelectedFinanceAccountsSortValue] = useState<any>('')
  const [selectedAdvisorsMentorsValue, setSelectedAdvisorsMentorsValue] = useState<any>('')
  const [selectedAdvisorsMentorsSortValue, setSelectedAdvisorsMentorsSortValue] = useState<any>('')
  const [selectedComplianceMeetingTypeValue, setSelectedComplianceMeetingTypeValue] =
    useState<any>('')
  const [selectedComplianceMeetingDateValue, setSelectedComplianceMeetingDateValue] =
    useState<any>('')

  const [
    selectedConvertibleSecurityClassesSortValue,
    setSelectedConvertibleSecurityClassesSortValue,
  ] = useState<any>('')
  const [
    selectedConvertibleSecurityClassesRateValue,
    setSelectedConvertibleSecurityClassesRateValue,
  ] = useState<any>('')

  const [selectedWarrantSecurityClassesSortValue, setSelectedWarrantSecurityClassesSortValue] =
    useState<any>('')

  const [selectedShareTransactionSortValue, setSelectedShareTransactionSortValue] =
    useState<any>('')
  const [selectedShareTransactionDateValue, setSelectedShareTransactionDateValue] =
    useState<any>('')

  const [selectedConvertibleTransactionSortValue, setSelectedConvertibleTransactionSortValue] =
    useState<any>('')
  const [selectedConvertibleTransactionDateValue, setSelectedConvertibleTransactionDateValue] =
    useState<any>('')

  const [selectedWarrantTransactionSortValue, setSelectedWarrantTransactionSortValue] =
    useState<any>('')
  const [selectedWarrantTransactionDateValue, setSelectedWarrantTransactionDateValue] =
    useState<any>('')

  const [selectedBuybackTransactionSortValue, setSelectedBuybackTransactionSortValue] =
    useState<any>('')
  const [selectedBuybackTransactionDateValue, setSelectedBuybackTransactionDateValue] =
    useState<any>('')
  const [selectedTransferTransactionSortValue, setSelectedTransferTransactionSortValue] =
    useState<any>('')
  const [selectedTransferTransactionDateValue, setSelectedTransferTransactionDateValue] =
    useState<any>('')

  const [selectedShareholderTypeValue, setSelectedShareholderTypeValue] = useState<any>('')
  const [selectedShareholderSortTypeValue, setSelectedShareholderSortTypeValue] = useState<any>('')
  const [selectedActivityLogTypeFilterValue, setSelectedActivityLogTypeFilterValue] =
    useState<any>('')
  const [selectedSecurityPermissionTypeFilterValue, setSelectedSecurityPermissionTypeFilterValue] =
    useState<any>('')
  const [selectedLevelTypeFilterValue, setSelectedLevelTypeFilterValue] = useState<any>('')
  const [selectedActionTypeFilterValue, setSelectedActionTypeFilterValue] = useState<any>('')
  const [selectedReportTypeFilterValue, setSelectedReportTypeFilterValue] = useState<any>('')
  const [selectedScheduleTypeFilterValue, setSelectedScheduleTypeFilterValue] = useState<any>('')

  const checkFilterPresent = (selectedFilter: string) => {
    const index = appliedFilter.findIndex((item: any) => item.filterName === selectedFilter)
    return index
  }

  const handleSelectLocationChange = (selectedOption: any) => {
    setSelectedTargetLocationValue(selectedOption)
  }

  const handleSelectGeographiesChange = (selectedOption: any) => {
    setSelectedTargetGeographiesValue(selectedOption)
  }

  const handleSelectInvestorTypeChange = (selectedOption: any) => {
    setSelectedTargetInvestorTypeValue(selectedOption)
  }

  const getAllTargetSectors = async () => {
    try {
      if (investorDbFilter) {
        const {
          data: {data, success},
        } = await getFocusArea(searchTargetValue, 1, 20)
        if (success) {
          if (data) {
            let TargetSectors: any = []
            TargetSectors = data.map((sectors: any) => {
              return {
                id: sectors.investorFocusAreaId,
                label: sectors.name,
                value: sectors.name,
              }
            })
            setContextTargetSectors(TargetSectors)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getAllStageFocus = async () => {
    try {
      if (investorDbFilter) {
        const {
          data: {data, success},
        } = await getStageFocus(searchFocusValue, 1, 20)
        if (success) {
          if (data) {
            let stageFocus: any = []
            stageFocus = data.map((focus: any) => {
              return {
                id: focus.investorStageFocusId,
                label: focus.name,
                value: focus.name,
              }
            })
            setContextStageFocus(stageFocus)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getAllInvestorLocation = async () => {
    try {
      if (investorDbFilter) {
        const {
          data: {data, success},
        } = await getInvestorLocation(searchLocationValue, 1, 20)
        if (success) {
          if (data) {
            let investorLocation: any = []
            investorLocation = data.map((location: any) => {
              return {
                id: location.investorLocationId,
                label: location.name,
                value: location.name,
              }
            })
            setContextInvestorLocation(investorLocation)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getAllInvestorGeographies = async () => {
    try {
      if (investorDbFilter) {
        const {
          data: {data, success},
        } = await getInvestorGeography(searchGeographiesValue, 1, 20)
        if (success) {
          if (data) {
            let investorGeographies: any = []
            investorGeographies = data.map((geographies: any) => {
              return {
                id: geographies.investorGeographyId,
                label: geographies.name,
                value: geographies.name,
              }
            })
            setContextInvestorGeographies(investorGeographies)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getAllTargetSectors()
  }, [investorDbFilter, searchTargetValue])

  useEffect(() => {
    getAllStageFocus()
  }, [investorDbFilter, searchFocusValue])

  useEffect(() => {
    getAllInvestorLocation()
  }, [investorDbFilter, searchLocationValue])

  useEffect(() => {
    getAllInvestorGeographies()
  }, [investorDbFilter, searchGeographiesValue])
  //InvestorUpdate

  const [investorUpdateStatus, setInvestorUpdateStatus] = useState<string>(
    investorUpdateStatusFilter || ''
  )

  const customStyles = {
    placeholder: (provided: any, state: any) => ({
      ...provided,
      fontSize: 13,
      fontWeight: 500,
    }),
    input: (provided: any, state: any) => ({
      ...provided,
      fontSize: 13,
    }),
  }

  const DropdownIndicator = () => {
    return (
      <div className='me-3'>
        <img src={toAbsoluteUrl('/media/icons/investor/search.svg')} alt='search' />
      </div>
    )
  }

  //Pitch Deck

  const [pitchDeckStatus, setPitchDeckStatus] = useState<string>(pitchDeckStatusFilter || '')

  //template
  const [templateStatus, setTemplateStatus] = useState<string>(templateStatusFilter || '')

  //email
  const [emailStatus, setEmailStatus] = useState<string>(emailStatusFilter || '')

  //DataRoom
  const [dataRoomStatusLocal, setdataRoomStatusLocal] = useState<string>(dataRoomStatus || '')

  const {mode} = useThemeMode()
  useEffect(() => {
    if (
      investorCrmFilter ||
      isActivityFilter ||
      emailFilter ||
      templateFilter ||
      documentsSubmissionFilter ||
      investorUpdateFilter ||
      pitchDeckFilter ||
      dataRoomFilter ||
      investorDbFilter ||
      founderPromoterFilter ||
      teamManagementFilter ||
      boardMemberFilter ||
      legalCompilanceFilter ||
      complianceMeetingFilter ||
      convertibleSecurityClassesFilter ||
      warrantSecurityClassesFilter ||
      financeAccountsFilter ||
      advisorsMentorsFilter ||
      shareTransactionFilter ||
      convertibleTransactionFilter ||
      warrantTransactionFilter ||
      buybackTransactionFilter ||
      transferTransactionFilter ||
      shareSecurityClassesSortFilter ||
      convertibleSecurityClassesFilter ||
      warrantSecurityClassesFilter ||
      shareholderFilter ||
      activityLogFilter ||
      securityPermissionFilter ||
      selectedLevelFilter ||
      selectedActionFilter ||
      selectedReportFilter||
      selectedScheduleFilter
    ) {
      setBlockOutsideClick(true)
    }
  }, [
    investorCrmFilter,
    isActivityFilter,
    emailFilter,
    templateFilter,
    documentsSubmissionFilter,
    investorUpdateFilter,
    pitchDeckFilter,
    dataRoomFilter,
    investorDbFilter,
    founderPromoterFilter,
    teamManagementFilter,
    boardMemberFilter,
    legalCompilanceFilter,
    complianceMeetingFilter,
    financeAccountsFilter,
    advisorsMentorsFilter,
    shareTransactionFilter,
    convertibleTransactionFilter,
    warrantTransactionFilter,
    buybackTransactionFilter,
    transferTransactionFilter,
    shareSecurityClassesSortFilter,
    convertibleSecurityClassesFilter,
    warrantSecurityClassesFilter,
    shareholderFilter,
    activityLogFilter,
    securityPermissionFilter,
    selectedLevelFilter,
    selectedActionFilter,
    selectedReportFilter,
    selectedScheduleFilter
  ])

  const clearFilterData = () => {
    setAppliedFilter([])
    if (isActivityFilter) {
      setActivityType('')
      setActivityStatus('')
      setSortActivity('')
      setFilterActivity!(undefined)
      set_sort_by_activity!(undefined)
      set_sort_order_activty!(undefined)
      setIsActivityFilter!(false)
    }
    if (investorCrmFilter) {
      setSortInvestorCrm('')
      set_sort_by_investor!(undefined)
      set_sort_order_investor!(undefined)
      setInvestorCrmFilter!(false)
    }
    if (investorDbFilter) {
      setSortInvestorDb('')
      set_sort_by_investorDb(undefined)
      set_sort_order_investorDb(undefined)
      setInvestorDbFilter(false)
      setSelectedTargetValue('')
      setSelectedStageFocusValue('')
      setSelectedTargetLocationValue('')
      setSelectedContextTargetValue('')
      setSelectedStageContextFocusValue('')
      setSelectedTargetContextLocationValue('')
      setSelectedTargetContextGeographiesValue('')
      setSelectedTargetContextInvestorTypeValue('')
      setSelectedTargetGeographiesValue('')
      setSelectedTargetInvestorTypeValue('')
    }
    if (investorUpdateFilter) {
      setInvestorUpdateStatus('')
      setInvestorUpdateStatusFilter('')
      setInvestorUpdateFilter(false)
    }
    if (pitchDeckFilter) {
      setPitchDeckStatus('')
      setpitchDeckStatusFilter('')
      setPitchDeckFilter(false)
    }
    if (templateFilter) {
      setTemplateStatus('')
      setTemplateStatusFilter('')
      setTemplateFilter(false)
    }
    if (emailFilter) {
      setEmailStatus('')
      setEmailStatusFilter('')
      setEmailFilter(false)
    }
    if (dataRoomFilter) {
      setDataRoomStatus!('')
      setdataRoomStatusLocal('')
      setDataRoomFilter!(false)
    }
    if (templateTypesFilter) {
      setSelectedTemplateTypeFilter('')
      setSelectedTemplateTypeValue('')
    }
    if (founderPromoterFilter) {
      setSelectedFounderPromoterValue('')
      setSelectedFounderPromoterSortValue('')
      setSelectedFounderPromoterTypeFilter('')
      setSelectedFounderPromoterSortTypeFilter('')
    }
    if (teamManagementFilter) {
      setSelectedTeamManagementSortValue('')
      setSelectedTeamManagementTypeFilter('')
    }

    if (shareSecurityClassesSortFilter) {
      setSelectedShareSecurityClassesSortValue('')
      setSelectedShareSecurityClassesSortFilter('')
    }
    if (boardMemberFilter) {
      setSelectedBoardMemberSortValue('')
      setSelectedBoardMemberTypeFilter('')
    }
    if (documentsSubmissionFilter) {
      setSelectedDocumentStatusFilter('')
      setSelectedDocumentsStatusValue('')
      setSelectedDoucmentSignatureStatusFilter('')
      setSelectedDocumentsSignatureStatusValue('')
    }
    if (legalCompilanceFilter) {
      setSelectedLegalCompilanceValue('')
      setSelectedLegalCompilanceSortValue('')
      setSelectedLegalCompilanceTypeFilter('')
      setSelectedLegalCompilanceSortTypeFilter('')
    }

    if (shareTransactionFilter) {
      setSelectedShareTransactionSortValue('')
      setSelectedShareTransactionSortFilter('')
      setSelectedShareTransactionDateValue('')
      setSelectedShareTransactionDateFilter('')
    }

    if (convertibleTransactionFilter) {
      setSelectedConvertibleTransactionSortValue('')
      setSelectedConvertibleTransactionSortFilter('')
      setSelectedConvertibleTransactionDateValue('')
      setSelectedConvertibleTransactionDateFilter('')
    }

    if (warrantTransactionFilter) {
      setSelectedWarrantTransactionSortValue('')
      setSelectedWarrantTransactionSortFilter('')
      setSelectedWarrantTransactionDateValue('')
      setSelectedWarrantTransactionDateFilter('')
    }

    if (buybackTransactionFilter) {
      setSelectedBuybackTransactionSortValue('')
      setSelectedBuybackTransactionSortFilter('')
      setSelectedBuybackTransactionDateValue('')
      setSelectedBuybackTransactionDateFilter('')
    }

    if (transferTransactionFilter) {
      setSelectedTransferTransactionSortValue('')
      setSelectedTransferTransactionSortFilter('')
      setSelectedTransferTransactionDateValue('')
      setSelectedTransferTransactionDateFilter('')
    }

    if (complianceMeetingFilter) {
      setSelectedComplianceMeetingTypeFilter('')
      setSelectedComplianceMeetingDateFilter('')
      setSelectedComplianceMeetingTypeValue('')
      setSelectedComplianceMeetingDateValue('')
    }

    if (convertibleSecurityClassesFilter) {
      setSelectedConvertibleSecurityClassesSortValue('')
      setSelectedConvertibleSecurityClassesRateValue('')
      setSelectedConvertibleSecurityClassesSortFilter('')
      setSelectedConvertibleSecurityClassesRateFilter('')
    }

    if (warrantSecurityClassesFilter) {
      setSelectedWarrantSecurityClassesSortValue('')
      setSelectedWarrantSecurityClassesSortFilter('')
    }

    if (financeAccountsFilter) {
      setSelectedFinanceAccountsValue('')
      setSelectedFinanceAccountsSortValue('')
      setSelectedFinanceAccountsTypeFilter('')
      setSelectedFinanceAccountsSortTypeFilter('')
    }
    if (advisorsMentorsFilter) {
      setSelectedAdvisorsMentorsValue('')
      setSelectedAdvisorsMentorsSortValue('')
      setSelectedAdvisorsMentorsTypeFilter('')
      setSelectedAdvisorsMentorsSortTypeFilter('')
    }

    if (shareholderFilter) {
      setSelectedShareholderTypeValue('')
      setSelectedShareholderSortTypeValue('')
      setSelectedShareholderTypeFilter('')
      setSelectedShareholderSortTypeFilter('')
    }

    if (activityLogFilter) {
      setSelectedActivityLogTypeFilterValue('')
      setSelectedActivityLogTypeFilter('')
    }
    if (securityPermissionFilter) {
      setSelectedSecurityPermissionTypeFilterValue('')
      setSelectedSecurityPermissionTypeFilter('')
    }
    if (selectedLevelFilter) {
      setSelectedLevelTypeFilterValue('')
      setSelectedLevelTypeFilter('')
    }
    if (selectedActionFilter) {
      setSelectedActionTypeFilterValue('')
      setSelectedActionTypeFilter('')
    }
    if (selectedReportFilter) {
      setSelectedReportTypeFilterValue('')
      setSelectedReportTypeFilter('')
    }
    if (selectedScheduleFilter) {
      setSelectedScheduleTypeFilterValue('')
      setSelectedScheduleTypeFilter('')
    }

    closeFilter()
  }

  const onApplyFilter = () => {
    try {
      setFilterLoading(true)
      if (isActivityFilter) {
        if (activitytype.length > 0 && activityStatus.length > 0) {
          setFilterActivity!(`activityType=${activitytype}&status=${activityStatus}`)
        } else if (activitytype.length > 0) {
          setFilterActivity!(`activityType=${activitytype}`)
        } else if (activityStatus.length > 0) {
          setFilterActivity!(`status=${activityStatus}`)
        }

        if (sortActivity.length > 0) {
          const sortData = sortActivity.split('-')
          set_sort_by_activity!(sortData[0])
          set_sort_order_activty!(sortData[1])
        }
        setFilterLoading(false)
        setIsActivityFilter!(false)
      }
      if (investorCrmFilter) {
        if (sortInvestorCrm.length > 0) {
          const sortData = sortInvestorCrm.split('-')
          set_sort_by_investor!(sortData[0])
          set_sort_order_investor!(sortData[1])
        }
        setFilterLoading(false)
        setInvestorCrmFilter!(false)
      }
      if (investorDbFilter) {
        let tempFilters = [...appliedFilter]
        if (sortInvestorDb.length > 0) {
          const sortData = sortInvestorDb.split('-')
          set_sort_by_investorDb!(sortData[0])
          set_sort_order_investorDb!(sortData[1])
        }
        if (selectedTargetValue?.value) {
          setSelectedContextTargetValue(selectedTargetValue?.value)
          const index = checkFilterPresent('Target Sector')
          if (index === -1) {
            tempFilters.push({
              filterName: 'Target Sector',
              contextName: setSelectedContextTargetValue,
              stateName: setSelectedTargetValue,
              name: selectedTargetValue.label,
            })
          } else {
            tempFilters[index] = {
              ...tempFilters[index],
              name: selectedTargetValue.label,
            }
          }
        }
        if (selectedStageFocusValue?.value) {
          setSelectedStageContextFocusValue(selectedStageFocusValue?.value)
          const index = checkFilterPresent('Stage Focus')
          if (index === -1) {
            tempFilters.push({
              filterName: 'Stage Focus',
              contextName: setSelectedStageContextFocusValue,
              stateName: setSelectedStageFocusValue,
              name: selectedStageFocusValue.label,
            })
          } else {
            tempFilters[index] = {
              ...tempFilters[index],
              name: selectedStageFocusValue.label,
            }
          }
        }
        if (selectedTargetLocationValue?.value) {
          setSelectedTargetContextLocationValue(selectedTargetLocationValue?.value)
          const index = checkFilterPresent('Investor Location')
          if (index === -1) {
            tempFilters.push({
              contextName: setSelectedTargetContextLocationValue,
              stateName: setSelectedTargetLocationValue,
              filterName: 'Investor Location',
              name: selectedTargetLocationValue.label,
            })
          } else {
            tempFilters[index] = {
              ...tempFilters[index],
              name: selectedTargetLocationValue.label,
            }
          }
        }
        if (selectedTargetGeographiesValue?.value) {
          setSelectedTargetContextGeographiesValue(selectedTargetGeographiesValue?.value)
          const index = checkFilterPresent('Investor Geographies')
          if (index === -1) {
            tempFilters.push({
              filterName: 'Investor Geographies',
              name: selectedTargetGeographiesValue.label,
              contextName: setSelectedTargetContextGeographiesValue,
              stateName: setSelectedTargetGeographiesValue,
            })
          } else {
            tempFilters[index] = {
              ...tempFilters[index],
              name: selectedTargetGeographiesValue.label,
            }
          }
        }
        if (selectedTargetInvestorTypeValue?.value) {
          setSelectedTargetContextInvestorTypeValue(selectedTargetInvestorTypeValue?.value)
          const index = checkFilterPresent('Investor Type')
          if (index === -1) {
            tempFilters.push({
              filterName: 'Investor Type',
              name: selectedTargetInvestorTypeValue.label,
              contextName: setSelectedTargetContextInvestorTypeValue,
              stateName: setSelectedTargetInvestorTypeValue,
            })
          } else {
            tempFilters[index] = {
              ...tempFilters[index],
              name: selectedTargetInvestorTypeValue.label,
            }
          }
        }
        setAppliedFilter([...tempFilters])
        setFilterLoading(false)
        setInvestorDbFilter(false)
      }
      if (investorUpdateFilter) {
        if (investorUpdateStatus.length > 0) {
          setInvestorUpdateStatusFilter!(investorUpdateStatus)
        }
        setFilterLoading(false)
        setInvestorUpdateFilter(false)
      }

      if (pitchDeckFilter) {
        if (pitchDeckStatus.length > 0) {
          setpitchDeckStatusFilter!(pitchDeckStatus)
        }
        setFilterLoading(false)
        setPitchDeckFilter(false)
      }

      if (templateTypesFilter) {
        setSelectedTemplateTypeFilter(selectedTemplateTypeValue.value)
        setFilterLoading(false)
      }

      if (founderPromoterFilter) {
        setSelectedFounderPromoterTypeFilter(selectedFounderPromoterValue.value)
        setSelectedFounderPromoterSortTypeFilter(selectedFounderPromoterSortValue.value)
        setFilterLoading(false)
      }

      if (teamManagementFilter) {
        setSelectedTeamManagementTypeFilter(selectedTeamManagementSortValue.value)
        setFilterLoading(false)
      }

      if (shareSecurityClassesSortFilter) {
        setSelectedShareSecurityClassesSortFilter(selectedShareSecurityClassesSortValue.value)
        setFilterLoading(false)
      }
      if (activityLogFilter) {
        setSelectedActivityLogTypeFilter(selectedActivityLogTypeFilterValue.value)
        setFilterLoading(false)
      }
      if (securityPermissionFilter) {
        setSelectedSecurityPermissionTypeFilter(selectedSecurityPermissionTypeFilterValue.value)
        setFilterLoading(false)
      }
      if (selectedLevelFilter) {
        setSelectedLevelTypeFilter(selectedLevelTypeFilterValue.value)
        setFilterLoading(false)
      }
      if (selectedActionFilter) {
        setSelectedActionTypeFilter(selectedActionTypeFilterValue.value)
        setFilterLoading(false)
      }
      if (selectedReportFilter) {
        setSelectedReportTypeFilter(selectedReportTypeFilterValue.value)
        setFilterLoading(false)
      }
      if (selectedScheduleFilter) {
        setSelectedScheduleTypeFilter(selectedScheduleTypeFilterValue.value)
        setFilterLoading(false)
      }
      if (boardMemberFilter) {
        setSelectedBoardMemberTypeFilter(selectedBoardMemberSortValue.value)
        setFilterLoading(false)
      }
      if (legalCompilanceFilter) {
        setSelectedLegalCompilanceTypeFilter(selectedLegalCompilanceValue.value)
        setSelectedLegalCompilanceSortTypeFilter(selectedLegalCompilanceSortValue.value)
        setFilterLoading(false)
      }

      if (shareTransactionFilter) {
        setSelectedShareTransactionSortFilter(selectedShareTransactionSortValue.value)
        setSelectedShareTransactionDateFilter(selectedShareTransactionDateValue)
        setFilterLoading(false)
      }

      if (convertibleTransactionFilter) {
        setSelectedConvertibleTransactionSortFilter(selectedConvertibleTransactionSortValue.value)
        setSelectedConvertibleTransactionDateFilter(selectedConvertibleTransactionDateValue)
        setFilterLoading(false)
      }

      if (warrantTransactionFilter) {
        setSelectedWarrantTransactionSortFilter(selectedWarrantTransactionSortValue.value)
        setSelectedWarrantTransactionDateFilter(selectedWarrantTransactionDateValue)
        setFilterLoading(false)
      }

      if (buybackTransactionFilter) {
        setSelectedBuybackTransactionSortFilter(selectedBuybackTransactionSortValue.value)
        setSelectedBuybackTransactionDateFilter(selectedBuybackTransactionDateValue)
        setFilterLoading(false)
      }

      if (transferTransactionFilter) {
        setSelectedTransferTransactionSortFilter(selectedTransferTransactionSortValue.value)
        setSelectedTransferTransactionDateFilter(selectedTransferTransactionDateValue)
        setFilterLoading(false)
      }

      if (complianceMeetingFilter) {
        setSelectedComplianceMeetingTypeFilter(selectedComplianceMeetingTypeValue.value)
        setSelectedComplianceMeetingDateFilter(selectedComplianceMeetingDateValue)
        setFilterLoading(false)
      }

      if (shareholderFilter) {
        setSelectedShareholderTypeFilter(selectedShareholderTypeValue.value)
        setSelectedShareholderSortTypeFilter(selectedShareholderSortTypeValue.value)
        setFilterLoading(false)
      }

      if (convertibleSecurityClassesFilter) {
        setSelectedConvertibleSecurityClassesSortFilter(
          selectedConvertibleSecurityClassesSortValue.value
        )
        setSelectedConvertibleSecurityClassesRateFilter(
          selectedConvertibleSecurityClassesRateValue.value
        )
        setFilterLoading(false)
      }

      if (warrantSecurityClassesFilter) {
        setSelectedWarrantSecurityClassesSortFilter(selectedWarrantSecurityClassesSortValue.value)
        setFilterLoading(false)
      }
      if (financeAccountsFilter) {
        setSelectedFinanceAccountsTypeFilter(selectedFinanceAccountsValue.value)
        setSelectedFinanceAccountsSortTypeFilter(selectedFinanceAccountsSortValue.value)
        setFilterLoading(false)
      }
      if (advisorsMentorsFilter) {
        setSelectedAdvisorsMentorsTypeFilter(selectedAdvisorsMentorsValue.value)
        setSelectedAdvisorsMentorsSortTypeFilter(selectedAdvisorsMentorsSortValue.value)
        setFilterLoading(false)
      }

      if (documentsSubmissionFilter) {
        setSelectedDocumentStatusFilter(selectedDocumentsStatusValue.value)
        setSelectedDoucmentSignatureStatusFilter(selectedDocumentsSignatureStatusValue.value)
        setFilterLoading(false)
      }

      if (templateFilter) {
        if (templateStatus.length > 0) {
          setTemplateStatusFilter!(templateStatus)
        }
        setFilterLoading(false)
        setTemplateFilter(false)
      }

      if (emailFilter) {
        if (emailStatus.length > 0) {
          setEmailStatusFilter!(emailStatus)
        }
        setFilterLoading(false)
        setEmailFilter(false)
      }

      if (dataRoomFilter) {
        if (dataRoomStatusLocal && dataRoomStatusLocal.length > 0) {
          setDataRoomStatus!(dataRoomStatusLocal)
        }
        setFilterLoading(false)
        setDataRoomFilter!(false)
      }
    } catch (err) {
      setFilterLoading(false)
      console.log(err)
    } finally {
      closeFilter()
    }
  }

  return (
    <div
      className={
        investorCrmFilter ||
        isActivityFilter ||
        emailFilter ||
        templateFilter ||
        investorUpdateFilter ||
        pitchDeckFilter ||
        dataRoomFilter ||
        investorDbFilter ||
        templateTypesFilter ||
        founderPromoterFilter ||
        teamManagementFilter ||
        shareSecurityClassesSortFilter ||
        boardMemberFilter ||
        documentsSubmissionFilter ||
        legalCompilanceFilter ||
        complianceMeetingFilter ||
        convertibleSecurityClassesFilter ||
        warrantSecurityClassesFilter ||
        financeAccountsFilter ||
        advisorsMentorsFilter ||
        shareTransactionFilter ||
        convertibleTransactionFilter ||
        warrantTransactionFilter ||
        buybackTransactionFilter ||
        transferTransactionFilter ||
        shareholderFilter ||
        activityLogFilter ||
        securityPermissionFilter ||
        selectedLevelFilter ||
        selectedActionFilter ||
        selectedReportFilter||
        selectedScheduleFilter
          ? 'bg-body drawer drawer-end drawer-on'
          : 'bg-body drawer drawer-end'
      }
      id='fc-filter'
      data-kt-drawer='true'
      data-kt-drawer-name='filter'
      data-kt-drawer-overlay='true'
      data-kt-drawer-activate='true'
      data-kt-drawer-width="{default:'300px', 'md': '400px'}"
      data-kt-drawer-direction='end'
      style={{width: '400px'}}
    >
      {/* begin::Card */}
      <div className='card shadow-none rounded-0 w-100'>
        {/* begin::Header */}
        <div className='card-header' id='fc_header'>
          <div className='card-toolbar gap-6'>
            <button
              type='button'
              className='btn btn-sm btn-icon explore-btn-dismiss me-n5'
              onClick={closeFilter}
            >
              <img src={crossIcon} alt=''></img>
            </button>
            <h5 className='card-title fw-bold'>{formatMessage({id: 'Sort or Filter'})}</h5>
          </div>
          {/* end::Header */}
        </div>
        {/* begin::Body */}
        <div className='card-body'>
          <div className='mb-5'>
            <BasicButton
              id='fc-close'
              height='36px'
              border='none'
              color={mode === 'dark' ? '#323248' : '#F5F8FA'}
              textColor={mode === 'dark' ? '#FFFFFF' : '#585960'}
              padding='8px 16px'
              buttonText={formatMessage({id: 'Clear All filters'})}
              minWidth={125}
              onClick={() => clearFilterData()}
              customClass='w-100 w-md-auto'
            />
          </div>
          {appliedFilter.map((item: any) => {
            return (
              <FilterPills
                key={item.name}
                filterName={item.filterName}
                pillName={item.name}
                deleteFilter={() => deleteFilter(item.name, item?.contextName, item?.stateName)}
              />
            )
          })}
          {isActivityFilter ? (
            <>
              <div className='mb-5'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Filter by Activty Type'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.FILTER.ACTIVITY_TYPE',
                    })}
                  />
                </label>
                <select
                  className='form-select form-select-lg h-40px font-size-13'
                  value={activitytype}
                  onChange={(e: any) => setActivityType(e.target.value)}
                >
                  {activityTypeConst.map((type) => (
                    <option key={type.id} value={type.value} disabled={type.disabled}>
                      {formatMessage({id: type.name})}
                    </option>
                  ))}
                </select>
              </div>
              <div className='mb-5'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Filter by Activty Status'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.FILTER.ACTIVITY_STATUS',
                    })}
                  />
                </label>
                <select
                  className='form-select form-select-lg h-40px font-size-13'
                  value={activityStatus}
                  onChange={(e: any) => setActivityStatus(e.target.value)}
                >
                  {activityStatusConst.map((type) => (
                    <option key={type.id} value={type.value} disabled={type.disabled}>
                      {formatMessage({id: type.name})}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Sort Activity By'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.SORT.ACTIVITY',
                    })}
                  />
                </label>
                <select
                  className='form-select form-select-lg h-40px font-size-13'
                  value={sortActivity}
                  onChange={(e: any) => setSortActivity(e.target.value)}
                >
                  {sortActivityConst.map((sort) => (
                    <option key={sort.id} value={sort.value} disabled={sort.disabled}>
                      {formatMessage({id: sort.name})}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : (
            ''
          )}

          {investorCrmFilter ? (
            <>
              <div>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Sort Investor By'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.SORT.INVESTOR',
                    })}
                  />
                </label>
                <select
                  className='form-select form-select-lg h-40px font-size-13'
                  value={sortInvestorCrm}
                  onChange={(e: any) => setSortInvestorCrm(e.target.value)}
                >
                  <option value='' disabled selected>
                    {formatMessage({id: 'select sorting order'})}
                  </option>

                  {sortInvestorCrmConst.map((sort) => (
                    <option key={sort.id} value={sort.value}>
                      {formatMessage({id: `${sort.name}`})}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : (
            ''
          )}

          {investorDbFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0 d-flex align-items-center'>
                    {formatMessage({id: 'Sort Investors By'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.INVESTORDB',
                      })}
                    />
                  </label>
                  <select
                    className='form-select form-select-lg h-40px font-size-13'
                    value={sortInvestorDb}
                    onChange={(e: any) => {
                      setSortInvestorDb(e.target.value)
                    }}
                  >
                    <option value='' disabled selected>
                      {formatMessage({id: 'select sorting order'})}
                    </option>
                    {sortInvestorDbConst.map((sort) => (
                      <option key={sort.id} value={sort.value}>
                        {formatMessage({id: sort.name})}
                      </option>
                    ))}
                  </select>
                </div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0 d-flex align-items-center'>
                    {formatMessage({id: 'Target sector'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'select Target Sector'})}
                    options={contextTargetSectors}
                    value={selectedTargetValue}
                    onInputChange={(e) => {
                      setSearchTargetValue(e)
                    }}
                    onChange={handleSelectTargetChange}
                  />
                </div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0 d-flex align-items-center'>
                    {formatMessage({id: 'Stage Focus'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.INVESTORDB',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'select Stage Focus'})}
                    options={contextStageFocus}
                    value={selectedStageFocusValue}
                    onChange={handleSelectFocusChange}
                    onInputChange={(e) => setSearchFocusValue(e)}
                  />
                </div>
                <div className='mb-3 d-none'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0 d-flex align-items-center'>
                    {formatMessage({id: 'Investor Location'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.INVESTORDB',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'select Investor Location'})}
                    options={contextInvestorLocation}
                    value={selectedTargetLocationValue}
                    onChange={handleSelectLocationChange}
                    onInputChange={(e) => setSearchLocationValue(e)}
                  />
                </div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0 d-flex align-items-center'>
                    {formatMessage({id: 'Investor Target Geographies'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.INVESTORDB',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'select Investor Geographies'})}
                    options={contextInvestorGeographies}
                    value={selectedTargetGeographiesValue}
                    onChange={handleSelectGeographiesChange}
                    onInputChange={(e) => setSearchGeographiesValue(e)}
                  />
                </div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0 d-flex align-items-center'>
                    {formatMessage({id: 'Investor Type'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.INVESTORDB',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'select Investor Type'})}
                    options={fundTypeOptions}
                    value={selectedTargetInvestorTypeValue}
                    onChange={handleSelectInvestorTypeChange}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {/* Digital Signing Filter start */}
          {templateTypesFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Filter by Template Type'})}{' '}
                    <ToolTipUI
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select Template Types'})}
                    options={TemplateTypeOptions}
                    value={selectedTemplateTypeValue}
                    onChange={(e) => setSelectedTemplateTypeValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {founderPromoterFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Filter by Founder or Promoter Type'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select Founder and Promoter Type'})}
                    options={FounderPromoterOptions}
                    value={selectedFounderPromoterValue}
                    onChange={(e) => setSelectedFounderPromoterValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {founderPromoterFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Sort by Name'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'firstName'},
                      {id: 2, label: 'DESC', value: '-firstName'},
                    ]}
                    value={selectedFounderPromoterSortValue}
                    onChange={(e) => setSelectedFounderPromoterSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {teamManagementFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Sort by Name'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'firstName'},
                      {id: 2, label: 'DESC', value: '-firstName'},
                    ]}
                    value={selectedTeamManagementSortValue}
                    onChange={(e) => setSelectedTeamManagementSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {shareSecurityClassesSortFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Class Name Sort By'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'className'},
                      {id: 2, label: 'DESC', value: '-className'},
                    ]}
                    value={selectedShareSecurityClassesSortValue}
                    onChange={(e) => setSelectedShareSecurityClassesSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {boardMemberFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Sort by Name'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'firstName'},
                      {id: 2, label: 'DESC', value: '-firstName'},
                    ]}
                    value={selectedBoardMemberSortValue}
                    onChange={(e) => setSelectedBoardMemberSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {legalCompilanceFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Filter by Individual or Institution Type'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select Individual or Institution Type'})}
                    options={stakeholdersTypeOptions}
                    value={selectedLegalCompilanceValue}
                    onChange={(e) => setSelectedLegalCompilanceValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {legalCompilanceFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Sort by Name'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'firstName'},
                      {id: 2, label: 'DESC', value: '-firstName'},
                    ]}
                    value={selectedLegalCompilanceSortValue}
                    onChange={(e) => setSelectedLegalCompilanceSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {complianceMeetingFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Meeting Type'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select Meeting Type'})}
                    options={ComplianceAttendanceType}
                    value={selectedComplianceMeetingTypeValue}
                    onChange={(e) => setSelectedComplianceMeetingTypeValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {complianceMeetingFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'By Date'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <DatePicker
                    className='form form-control h-40px font-size-13'
                    selected={selectedComplianceMeetingDateValue}
                    onChange={(date: Date) => setSelectedComplianceMeetingDateValue(date)}
                    placeholderText='Select Meeting Date'
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {/* Shareholder Filter */}

          {shareholderFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Shareholder type'})}{' '}
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select Individual or Institution Type'})}
                    options={stakeholdersTypeOptions}
                    value={selectedShareholderTypeValue}
                    onChange={(e) => setSelectedShareholderTypeValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {shareholderFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Sort by Name'})}{' '}
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'firstName'},
                      {id: 2, label: 'DESC', value: '-firstName'},
                    ]}
                    value={selectedShareholderSortTypeValue}
                    onChange={(e) => setSelectedShareholderSortTypeValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {/* Convertible Security Classes Filter  */}

          {activityLogFilter ? (
            <div>
              <div className='mb-3'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Activity type'})}{' '}
                </label>
                <Select
                  components={{DropdownIndicator}}
                  styles={customStyles}
                  isSearchable={true}
                  classNamePrefix='react-select'
                  placeholder={formatMessage({id: 'Select Activity Type'})}
                  options={activityLogFilterOptions}
                  value={selectedActivityLogTypeFilterValue}
                  onChange={(e) => setSelectedActivityLogTypeFilterValue(e)}
                />
              </div>
            </div>
          ) : (
            ''
          )}

          {securityPermissionFilter ? (
            <div>
              <div className='mb-3'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Select role'})}{' '}
                </label>
                <Select
                  components={{DropdownIndicator}}
                  styles={customStyles}
                  isSearchable={true}
                  classNamePrefix='react-select'
                  placeholder={formatMessage({id: 'Select Role'})}
                  options={securityPermissionOptions}
                  value={selectedSecurityPermissionTypeFilterValue}
                  onChange={(e) => setSelectedSecurityPermissionTypeFilterValue(e)}
                />
              </div>
            </div>
          ) : (
            ''
          )}

          {selectedLevelFilter ? (
            <div>
              <div className='mb-3'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Select urgency'})}{' '}
                </label>
                <Select
                  components={{DropdownIndicator}}
                  styles={customStyles}
                  isSearchable={true}
                  classNamePrefix='react-select'
                  placeholder={formatMessage({id: 'Select Urgency'})}
                  options={urgencyOptions}
                  value={selectedLevelTypeFilterValue}
                  onChange={(e) => setSelectedLevelTypeFilterValue(e)}
                />
              </div>
            </div>
          ) : (
            ''
          )}

          {selectedActionFilter ? (
            <div>
              <div className='mb-3'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Select action'})}{' '}
                </label>
                <Select
                  components={{DropdownIndicator}}
                  styles={customStyles}
                  isSearchable={true}
                  classNamePrefix='react-select'
                  placeholder={formatMessage({id: 'Select Action'})}
                  options={actionOptions}
                  value={selectedActionTypeFilterValue}
                  onChange={(e) => setSelectedActionTypeFilterValue(e)}
                />
              </div>
            </div>
          ) : (
            ''
          )}

          {selectedReportFilter ? (
            <div>
              <div className='mb-3'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Select Report Type'})}{' '}
                </label>
                <Select
                  components={{DropdownIndicator}}
                  styles={customStyles}
                  isSearchable={true}
                  classNamePrefix='react-select'
                  placeholder={formatMessage({id: 'Select Report Type'})}
                  options={reportOptions}
                  value={selectedReportTypeFilterValue}
                  onChange={(e) => setSelectedReportTypeFilterValue(e)}
                />
              </div>
            </div>
          ) : (
            ''
          )}

          {selectedScheduleFilter ? (
            <div>
              <div className='mb-3'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Select Frequency Type'})}{' '}
                </label>
                <Select
                  components={{DropdownIndicator}}
                  styles={customStyles}
                  isSearchable={true}
                  classNamePrefix='react-select'
                  placeholder={formatMessage({id: 'Select Frequency Type'})}
                  options={frequencyOptions}
                  value={selectedScheduleTypeFilterValue}
                  onChange={(e) => setSelectedScheduleTypeFilterValue(e)}
                />
              </div>
            </div>
          ) : (
            ''
          )}

          {convertibleSecurityClassesFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Annual Rate in %'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select Annual Rate in %'})}
                    options={convertibleSecurityClassesRateOptions}
                    value={selectedConvertibleSecurityClassesRateValue}
                    onChange={(e) => setSelectedConvertibleSecurityClassesRateValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {convertibleSecurityClassesFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Class Name Sort by'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'className'},
                      {id: 2, label: 'DESC', value: '-className'},
                    ]}
                    value={selectedConvertibleSecurityClassesSortValue}
                    onChange={(e) => setSelectedConvertibleSecurityClassesSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {warrantSecurityClassesFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Class Name Sort by'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'className'},
                      {id: 2, label: 'DESC', value: '-className'},
                    ]}
                    value={selectedWarrantSecurityClassesSortValue}
                    onChange={(e) => setSelectedWarrantSecurityClassesSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {shareTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Class Name Sort by'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'className'},
                      {id: 2, label: 'DESC', value: '-className'},
                    ]}
                    value={selectedShareTransactionSortValue}
                    onChange={(e) => setSelectedShareTransactionSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {shareTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Issue Date'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <DatePicker
                    className='form form-control h-40px font-size-13'
                    selected={selectedShareTransactionDateValue}
                    onChange={(date: Date) => setSelectedShareTransactionDateValue(date)}
                    placeholderText='Select Meeting Date'
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {convertibleTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Class Name Sort by'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'className'},
                      {id: 2, label: 'DESC', value: '-className'},
                    ]}
                    value={selectedConvertibleTransactionSortValue}
                    onChange={(e) => setSelectedConvertibleTransactionSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {convertibleTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Issue Date'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <DatePicker
                    className='form form-control h-40px font-size-13'
                    selected={selectedConvertibleTransactionDateValue}
                    onChange={(date: Date) => setSelectedConvertibleTransactionDateValue(date)}
                    placeholderText='Select Meeting Date'
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {warrantTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Class Name Sort by'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'className'},
                      {id: 2, label: 'DESC', value: '-className'},
                    ]}
                    value={selectedWarrantTransactionSortValue}
                    onChange={(e) => setSelectedWarrantTransactionSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {warrantTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Issue Date'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <DatePicker
                    className='form form-control h-40px font-size-13'
                    selected={selectedWarrantTransactionDateValue}
                    onChange={(date: Date) => setSelectedWarrantTransactionDateValue(date)}
                    placeholderText='Select Meeting Date'
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {buybackTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Class Name Sort by'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'className'},
                      {id: 2, label: 'DESC', value: '-className'},
                    ]}
                    value={selectedBuybackTransactionSortValue}
                    onChange={(e) => setSelectedBuybackTransactionSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {buybackTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Buyback Date'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <DatePicker
                    className='form form-control h-40px font-size-13'
                    selected={selectedBuybackTransactionDateValue}
                    onChange={(date: Date) => setSelectedBuybackTransactionDateValue(date)}
                    placeholderText='Select Meeting Date'
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {transferTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Class Name Sort by'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'className'},
                      {id: 2, label: 'DESC', value: '-className'},
                    ]}
                    value={selectedTransferTransactionSortValue}
                    onChange={(e) => setSelectedTransferTransactionSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {transferTransactionFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Transfer Date'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <DatePicker
                    className='form form-control h-40px font-size-13'
                    selected={selectedTransferTransactionDateValue}
                    onChange={(date: Date) => setSelectedTransferTransactionDateValue(date)}
                    placeholderText='Select Meeting Date'
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {financeAccountsFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Filter by Individual or Institution Type'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select Individual or Institution Type'})}
                    options={stakeholdersTypeOptions}
                    value={selectedFinanceAccountsValue}
                    onChange={(e) => setSelectedFinanceAccountsValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {financeAccountsFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Sort by Name'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'firstName'},
                      {id: 2, label: 'DESC', value: '-firstName'},
                    ]}
                    value={selectedFinanceAccountsSortValue}
                    onChange={(e) => setSelectedFinanceAccountsSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {advisorsMentorsFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Filter by Individual or Institution Type'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select Individual or Institution Type'})}
                    options={stakeholdersTypeOptions}
                    value={selectedAdvisorsMentorsValue}
                    onChange={(e) => setSelectedAdvisorsMentorsValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {advisorsMentorsFilter ? (
            <>
              <div>
                <div className='mb-3'>
                  <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                    {formatMessage({id: 'Sort by Name'})}{' '}
                    <ToolTipUIForModal
                      tooltipText={formatMessage({
                        id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                      })}
                    />
                  </label>
                  <Select
                    components={{DropdownIndicator}}
                    styles={customStyles}
                    isSearchable={true}
                    classNamePrefix='react-select'
                    placeholder={formatMessage({id: 'Select ASC OR DESC (Alphabetic)'})}
                    options={[
                      {id: 1, label: 'ASC', value: 'firstName'},
                      {id: 2, label: 'DESC', value: '-firstName'},
                    ]}
                    value={selectedAdvisorsMentorsSortValue}
                    onChange={(e) => setSelectedAdvisorsMentorsSortValue(e)}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          {documentsSubmissionFilter ? (
            <div>
              <div className='mb-3'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Filter by Document Status'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                    })}
                  />
                </label>
                <Select
                  components={{DropdownIndicator}}
                  styles={customStyles}
                  isSearchable={true}
                  classNamePrefix='react-select'
                  placeholder={formatMessage({id: 'Select Document Status'})}
                  options={DocumentsStatusOptions}
                  value={selectedDocumentsStatusValue}
                  onChange={(e) => setSelectedDocumentsStatusValue(e)}
                />
              </div>
              <div className='mb-3'>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Filter by Document Signature Type'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.SORT.TARGER_SECTOR',
                    })}
                  />
                </label>
                <Select
                  components={{DropdownIndicator}}
                  styles={customStyles}
                  isSearchable={true}
                  classNamePrefix='react-select'
                  placeholder={formatMessage({id: 'Select Signature Type'})}
                  options={DocumentsSignatureStatusOptions}
                  value={selectedDocumentsSignatureStatusValue}
                  onChange={(e) => setSelectedDocumentsSignatureStatusValue(e)}
                />
              </div>
            </div>
          ) : (
            ''
          )}

          {/* Digital Signing Filter end */}

          {investorUpdateFilter ? (
            <>
              <div>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0 d-flex align-items-center'>
                  {formatMessage({id: 'Filter by Status Investor '})}{' '}
                  <ToolTipUIForModal
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.FILTER.INVESTOR_UPDATE',
                    })}
                  />
                </label>
                <select
                  className='form-select form-select-lg h-40px font-size-13'
                  value={investorUpdateStatus}
                  onChange={(e: any) => setInvestorUpdateStatus(e.target.value)}
                >
                  <option value='' disabled selected>
                    {formatMessage({id: 'Select status'})}
                  </option>

                  {investorUpdateFilterConst.map((type) => (
                    <option key={type.id} value={type.value}>
                      {formatMessage({id: type.name})}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : (
            ''
          )}

          {pitchDeckFilter ? (
            <>
              <div>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Filter by Status Pitchdeck'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.FILTER.PITCHDECK',
                    })}
                  />
                </label>
                <select
                  className='form-select form-select-lg h-40px font-size-13'
                  value={pitchDeckStatus}
                  onChange={(e: any) => setPitchDeckStatus(e.target.value)}
                >
                  <option value='' disabled selected>
                    {formatMessage({id: 'Select status'})}
                  </option>

                  {pitchDeckFilterConst.map((type) => (
                    <option key={type.id} value={type.value}>
                      {formatMessage({id: type.name})}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : (
            ''
          )}

          {templateFilter ? (
            <>
              <div>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Filter by Status Template'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.FILTER.TEMPLATE',
                    })}
                  />
                </label>
                <select
                  className='form-select form-select-lg h-40px font-size-13'
                  value={templateStatus}
                  onChange={(e: any) => setTemplateStatus(e.target.value)}
                >
                  <option value='' disabled selected>
                    {formatMessage({id: 'Select status'})}
                  </option>

                  {templateFilterConst.map((type) => (
                    <option key={type.id} value={type.value}>
                      {formatMessage({id: type.name})}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : (
            ''
          )}

          {emailFilter ? (
            <>
              <div>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Filter by Status Email'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.FILTER.EMAIL',
                    })}
                  />
                </label>
                <select
                  className='form-select form-select-lg h-40px font-size-13'
                  value={emailStatus}
                  onChange={(e: any) => setEmailStatus(e.target.value)}
                >
                  {emailFilterConst.map((type) => (
                    <option key={type.id} value={type.value} disabled={type.disabled}>
                      {formatMessage({id: type.name})}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : (
            ''
          )}

          {dataRoomFilter ? (
            <>
              <div>
                <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                  {formatMessage({id: 'Filter by Status'})}{' '}
                  <ToolTipUI
                    tooltipText={formatMessage({
                      id: 'GLOBAL.TOOLTIP.FILTER.DATAROOM_FILTER',
                    })}
                  />
                </label>
                <select
                  className='form-select form-select-lg h-40px font-size-13'
                  value={dataRoomStatusLocal}
                  onChange={(e: any) => setdataRoomStatusLocal(e.target.value)}
                >
                  {dataRoomTypeConst.map((type) => (
                    <option key={type.id} value={type.value} disabled={type.disabled}>
                      {formatMessage({id: type.name})}
                    </option>
                  ))}
                </select>
              </div>
            </>
          ) : (
            ''
          )}
        </div>
        {/* end::Body */}
        {/* begin::Footer */}
        <div className=' d-flex justify-content-center mx-4 mb-5' id='fc_footer'>
          <BasicButton
            id='fc-close'
            height='52px'
            border='#4776E6'
            color='#4776E6'
            textColor='#FFFFFF'
            // padding='16px 138px'
            buttonText={formatMessage({id: 'Apply filters'})}
            // minWidth={352}
            customClass='w-100'
            loading={filterLoading}
            disabled={filterLoading}
            onClick={() => onApplyFilter()}
          />
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Card */}
    </div>
  )
}
